/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/components/chat-icon/gorgias-chat-icon.js":
/*!**********************************************************!*\
  !*** ./src/js/components/chat-icon/gorgias-chat-icon.js ***!
  \**********************************************************/
/***/ (() => {

document.addEventListener("DOMContentLoaded", function () {
  function getChatButton() {
    return document.getElementById("chat-button");
  }
  function anyDrawerOpen() {
    return !!document.querySelector(".drawer[open], .cart-drawer[open], .predictive-search-drawer[open], .mobile-navigation[open], .facet-filters[open]");
  }
  function updateChatVisibility() {
    var chatButton = getChatButton();
    if (!chatButton) {
      return;
    }
    if (anyDrawerOpen()) {
      chatButton.classList.add("chat-hidden");
      chatButton.setAttribute("aria-hidden", "true");
      chatButton.setAttribute("tabindex", "-1");
      chatButton.addEventListener("transitionend", function handler() {
        if (chatButton.classList.contains("chat-hidden")) {
          chatButton.style.display = "none";
        }
        chatButton.removeEventListener("transitionend", handler);
      });
    } else {
      chatButton.style.display = "";
      void chatButton.offsetWidth;
      chatButton.classList.remove("chat-hidden");
      chatButton.removeAttribute("aria-hidden");
      chatButton.removeAttribute("tabindex");
    }
  }
  var drawers = document.querySelectorAll(".drawer, .cart-drawer, .predictive-search-drawer, .mobile-navigation, .facet-filters");
  drawers.forEach(function (drawer) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "open") {
          updateChatVisibility();
        }
      });
    }).observe(drawer, {
      attributes: true,
      attributeFilter: ["open"]
    });
  });
  updateChatVisibility();
  setTimeout(updateChatVisibility, 500);
});

/***/ }),

/***/ "./src/js/components/horizontal-slider/scrollable-container.js":
/*!*********************************************************************!*\
  !*** ./src/js/components/horizontal-slider/scrollable-container.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ setupHorizontalScroll)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Horizontal Scroll Module
 * Provides smooth desktop-only grab+drag + wheel momentum,
 * while trusting native mobile scrolling entirely.
 */

function setupHorizontalScroll(nav) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!nav || nav.dataset.scrollInit === "true") {
    return;
  }
  var config = _objectSpread({
    scrollSpeed: 0.8,
    dragSpeed: 1.2,
    wheelSpeed: 1.2,
    trackpadSpeed: 1.0,
    friction: 0.92,
    preventDrag: true,
    dragThreshold: 5
  }, options);
  nav.classList.add("scrollable-container");
  if (config.preventDrag) {
    nav.querySelectorAll("a, img, svg, button").forEach(function (el) {
      el.addEventListener("dragstart", function (e) {
        return e.preventDefault();
      });
      el.classList.add("scrollable-container__no-drag");
    });
  }
  var isDesktopDevice = window.matchMedia("(pointer: fine)").matches;
  var rafManager = {
    id: null,
    schedule: function schedule(fn) {
      this.cancel();
      this.id = requestAnimationFrame(fn);
    },
    cancel: function cancel() {
      if (this.id) cancelAnimationFrame(this.id), this.id = null;
    }
  };
  function safely(fn) {
    try {
      fn();
    } catch (err) {
      // silent fail
    }
  }
  function isAtBoundary() {
    return {
      isAtStart: nav.scrollLeft <= 0,
      isAtEnd: nav.scrollLeft >= nav.scrollWidth - nav.clientWidth
    };
  }
  function startMomentum(initialVelocity) {
    var v = initialVelocity;
    function step() {
      var _isAtBoundary = isAtBoundary(),
        isAtStart = _isAtBoundary.isAtStart,
        isAtEnd = _isAtBoundary.isAtEnd;
      if (Math.abs(v) > 0.5 && !isAtStart && !isAtEnd) {
        nav.scrollLeft += v;
        v *= config.friction;
        rafManager.schedule(step);
      }
    }
    rafManager.schedule(step);
  }
  var isDown = false;
  var startX = 0;
  var startScroll = 0;
  var lastTime = 0;
  var velBuf = [];
  var hasDragged = false;
  nav.addEventListener("mousedown", function (e) {
    return safely(function () {
      if (!isDesktopDevice || e.button !== 0) return;
      isDown = true;
      hasDragged = false;
      startX = e.clientX;
      startScroll = nav.scrollLeft;
      velBuf = [];
      lastTime = Date.now();
      nav.classList.add("is-dragging");
      e.preventDefault();
    });
  });
  document.addEventListener("mousemove", function (e) {
    return safely(function () {
      if (!isDown) return;
      var dx = e.clientX - startX;
      var now = Date.now();
      if (!hasDragged && Math.abs(dx) > config.dragThreshold) {
        hasDragged = true;
      }
      nav.scrollLeft = startScroll - dx;
      var dt = now - lastTime;
      if (dt > 0) {
        var _e$_prevX;
        var v = (e.clientX - ((_e$_prevX = e._prevX) !== null && _e$_prevX !== void 0 ? _e$_prevX : e.clientX)) / dt;
        velBuf.push(v);
        if (velBuf.length > 8) velBuf.shift();
        e._prevX = e.clientX;
        lastTime = now;
      }
    });
  });
  document.addEventListener("mouseup", function (e) {
    return safely(function () {
      if (!isDown) return;
      isDown = false;
      nav.classList.remove("is-dragging");
      var avgV = velBuf.reduce(function (a, b) {
        return a + b;
      }, 0) / velBuf.length || 0;
      startMomentum(avgV * config.dragSpeed * 100);
    });
  });
  nav.addEventListener("click", function (e) {
    if (hasDragged) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
  var wheelBuf = [];
  var wheelTimer = null;
  nav.addEventListener("wheel", function (e) {
    return safely(function () {
      if (e.deltaMode === 0) return;
      e.preventDefault();
      var delta = e.deltaX || e.deltaY;
      var moved = delta * config.wheelSpeed;
      nav.scrollLeft += moved;
      wheelBuf.push(moved);
      if (wheelBuf.length > 8) wheelBuf.shift();
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function () {
        var avgMoved = wheelBuf.reduce(function (a, b) {
          return a + b;
        }, 0) / wheelBuf.length || 0;
        startMomentum(avgMoved * config.scrollSpeed);
        wheelBuf = [];
      }, 50);
    });
  }, {
    passive: false
  });
  function cleanup() {
    rafManager.cancel();
    clearTimeout(wheelTimer);
  }
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) cleanup();
  });
  nav.dataset.scrollInit = "true";
  return cleanup;
}

/***/ }),

/***/ "./src/js/components/mini-cart/mini-cart-discount.js":
/*!***********************************************************!*\
  !*** ./src/js/components/mini-cart/mini-cart-discount.js ***!
  \***********************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function debounce(func, wait) {
  var timeout;
  return function executedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var later = function later() {
      clearTimeout(timeout);
      func.apply(void 0, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
function setLoading(isLoading) {
  var form = document.getElementById("cart-discount-form");
  var input = document.getElementById("cart-discount-code");
  var btn = document.getElementById("apply-cart-discount");
  if (!form || !input || !btn) return;
  if (isLoading) {
    form.classList.add("is-loading");
    input.setAttribute("disabled", "disabled");
    btn.classList.add("is-loading");
    btn.disabled = true;
  } else {
    form.classList.remove("is-loading");
    input.removeAttribute("disabled");
    btn.classList.remove("is-loading");
    btn.disabled = false;
  }
}
function showNotification(message, type) {
  var form = document.getElementById("cart-discount-form");
  if (!form) return;
  form.classList.remove("show-notification", "notification-success", "notification-error");
  form.dataset.message = message;
  form.dataset.type = type;
  form.classList.add("show-notification", "notification-".concat(type));
  setTimeout(function () {
    form.classList.remove("show-notification", "notification-".concat(type));
  }, 3000);
}
function formatMoney(cents, cart) {
  var _window$theme;
  if (!cents) return "";
  if (typeof ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : _window$theme.formatMoney) === "function") {
    return window.theme.formatMoney(cents);
  }
  try {
    var locale = document.documentElement.lang || "de-DE";
    var currency = (cart === null || cart === void 0 ? void 0 : cart.currency) || "EUR";
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency
    }).format(cents / 100);
  } catch (error) {
    return "".concat((cents / 100).toFixed(2), " \u20AC");
  }
}
function calculateAndDisplaySavings(cart) {
  var cartSavings = 0;
  cart.items.forEach(function (item) {
    var _item$variant;
    if (item !== null && item !== void 0 && (_item$variant = item.variant) !== null && _item$variant !== void 0 && _item$variant.compare_at_price && item.variant.price) {
      if (item.variant.compare_at_price > item.variant.price) {
        var itemSavings = (item.variant.compare_at_price - item.variant.price) * item.quantity;
        cartSavings += itemSavings;
      }
    }
  });
  var discountSavings = cart.original_total_price - cart.total_price;
  cartSavings += discountSavings;
  var saveRow = document.querySelector(".totals-save");
  var saveValue = document.querySelector(".total_save_value");
  if (saveRow && saveValue) {
    if (cartSavings > 0) {
      saveRow.style.display = "flex";
      saveValue.textContent = formatMoney(cartSavings, cart);
    } else {
      saveRow.style.display = "none";
    }
  }
}
function updateSavingsDisplay(cart) {
  calculateAndDisplaySavings(cart);
}
function refreshCart() {
  return _refreshCart.apply(this, arguments);
}
function _refreshCart() {
  _refreshCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var response, cart;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return fetch("/cart.js");
        case 3:
          response = _context3.sent;
          if (response.ok) {
            _context3.next = 6;
            break;
          }
          throw new Error("Failed to fetch cart");
        case 6:
          _context3.next = 8;
          return response.json();
        case 8:
          cart = _context3.sent;
          updateCartUI(cart);
          _context3.next = 15;
          break;
        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](0);
          showNotification("Fehler beim Aktualisieren des Warenkorbs", "error");
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 12]]);
  }));
  return _refreshCart.apply(this, arguments);
}
function updateCartUI(cart) {
  if (!cart) {
    return;
  }
  try {
    var cartUpdateEvent = new CustomEvent("cart:discount:updated", {
      bubbles: true,
      detail: {
        cart: cart
      }
    });
    document.dispatchEvent(cartUpdateEvent);
    updateSavingsDisplay(cart);
    var subtotalEl = document.querySelector(".cart__subtotal .money");
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, cart);
    var drawerSubtotal = document.querySelector(".totals__subtotal-value");
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price, cart);
    var drawerTotal = document.querySelector(".total-value-price");
    if (drawerTotal) drawerTotal.textContent = formatMoney(cart.total_price, cart);
    if (Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        if (!item) return;
        var lineItems = document.querySelectorAll('[class*="line-item"]');
        var lineItem = Array.from(lineItems).find(function (el) {
          var titleEl = el.querySelector(".product-item-meta__title");
          return titleEl && titleEl.textContent.trim() === item.title.trim();
        });
        if (!lineItem) return;
        lineItem.setAttribute("data-original-price", item.original_price);
        lineItem.setAttribute("data-final-price", item.final_price);
        lineItem.setAttribute("data-total-discount", item.total_discount);
        var priceContainer = lineItem.querySelector(".line-item__price-list-container .price-list .price-row");
        if (priceContainer) {
          var highlightPrice = priceContainer.querySelector(".price--highlight");
          var comparePrice = priceContainer.querySelector(".price--compare");
          var hasDiscount = item.original_price > item.final_price || item.variant.compare_at_price > item.variant.price;
          if (highlightPrice) {
            highlightPrice.innerHTML = "<span class=\"visually-hidden\">Angebotspreis</span>".concat(formatMoney(item.final_price, cart));
            if (hasDiscount) {
              highlightPrice.classList.add("price--highlight");
            } else {
              highlightPrice.classList.remove("price--highlight");
            }
          }
          if (comparePrice) {
            if (hasDiscount) {
              var comparePriceValue = item.variant.compare_at_price ? item.variant.compare_at_price * item.quantity : item.original_price;
              comparePrice.innerHTML = "<span class=\"visually-hidden\">Regul\xE4rer Preis</span>".concat(formatMoney(comparePriceValue, cart));
              comparePrice.style.display = "block";
            } else {
              comparePrice.style.display = "none";
            }
          }
        }
        var badge = lineItem.querySelector(".line-item__discount-badge");
        if (badge) {
          var _item$discounts, _cart$cart_level_disc, _cart$discount_codes;
          var hasLineDiscount = ((_item$discounts = item.discounts) === null || _item$discounts === void 0 ? void 0 : _item$discounts.length) > 0;
          var hasCartDiscount = ((_cart$cart_level_disc = cart.cart_level_discount_applications) === null || _cart$cart_level_disc === void 0 ? void 0 : _cart$cart_level_disc.length) > 0 || ((_cart$discount_codes = cart.discount_codes) === null || _cart$discount_codes === void 0 ? void 0 : _cart$discount_codes.length) > 0 && cart.discount_codes[0].applicable;
          if (hasLineDiscount || hasCartDiscount) {
            badge.style.display = "flex";
            if (hasLineDiscount) {
              badge.textContent = "".concat(item.discounts[0].title, " (-").concat(formatMoney(item.total_discount, cart), ")");
            } else if (hasCartDiscount) {
              var discountAmount = item.original_price - item.final_price;
              badge.textContent = "".concat(cart.discount_codes[0].code, " (-").concat(formatMoney(discountAmount, cart), ")");
            }
          } else {
            badge.style.display = "none";
          }
        }
      });
    }
    setLoading(false);
  } catch (error) {
    setLoading(false);
  }
}
document.addEventListener("cart:discount:updated", function (event) {
  var cart = event.detail.cart;
  if (!cart) return;
  document.querySelectorAll('[class*="line-item"]').forEach(function (lineItem) {
    var originalPrice = lineItem.getAttribute("data-original-price");
    var finalPrice = lineItem.getAttribute("data-final-price");
    var totalDiscount = lineItem.getAttribute("data-total-discount");
    if (!originalPrice || !finalPrice) return;
    var priceContainer = lineItem.querySelector(".line-item__price-list-container .price-list .price-row");
    if (!priceContainer) return;
    var highlightPrice = priceContainer.querySelector(".price--highlight");
    var comparePrice = priceContainer.querySelector(".price--compare");
    if (highlightPrice) {
      highlightPrice.innerHTML = "<span class=\"visually-hidden\">Angebotspreis</span>".concat(formatMoney(parseInt(finalPrice), cart));
    }
    if (comparePrice) {
      if (parseInt(originalPrice) > parseInt(finalPrice)) {
        comparePrice.innerHTML = "<span class=\"visually-hidden\">Regul\xE4rer Preis</span>".concat(formatMoney(parseInt(originalPrice), cart));
        comparePrice.style.display = "block";
      } else {
        comparePrice.style.display = "none";
      }
    }
    var badge = lineItem.querySelector(".line-item__discount-badge");
    if (badge && parseInt(totalDiscount) > 0) {
      badge.style.display = "flex";
      badge.textContent = "".concat(cart.discount_codes[0].code, " (-").concat(formatMoney(parseInt(totalDiscount), cart), ")");
    } else if (badge) {
      badge.style.display = "none";
    }
  });
});
function handleCartDiscountApply() {
  return _handleCartDiscountApply.apply(this, arguments);
}
function _handleCartDiscountApply() {
  _handleCartDiscountApply = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var input, code, _window$Shopify$route, cartResponse, currentCart, existingDiscounts, hasExistingValidDiscount, updateUrl, response, errJson, cart, cartSectionResponse, cartSectionHtml, newDiscounts, hasNewValidDiscount, invalidCodeRemoved, sameCodeRemoved;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          input = document.getElementById("cart-discount-code");
          if (input) {
            _context4.next = 3;
            break;
          }
          return _context4.abrupt("return");
        case 3:
          code = input.value.trim();
          if (code) {
            _context4.next = 7;
            break;
          }
          showNotification("Bitte Rabattcode eingeben", "error");
          return _context4.abrupt("return");
        case 7:
          setLoading(true);
          _context4.prev = 8;
          _context4.next = 11;
          return fetch("/cart.js");
        case 11:
          cartResponse = _context4.sent;
          _context4.next = 14;
          return cartResponse.json();
        case 14:
          currentCart = _context4.sent;
          existingDiscounts = currentCart.discount_codes || [];
          hasExistingValidDiscount = existingDiscounts.some(function (dc) {
            return dc.applicable;
          });
          updateUrl = ((_window$Shopify$route = window.Shopify.routes) === null || _window$Shopify$route === void 0 ? void 0 : _window$Shopify$route.root) + "cart/update.js" || 0;
          _context4.next = 20;
          return fetch(updateUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({
              discount: code,
              sections: ["mini-cart-items", "mini-cart-footer"]
            })
          });
        case 20:
          response = _context4.sent;
          if (response.ok) {
            _context4.next = 26;
            break;
          }
          _context4.next = 24;
          return response.json();
        case 24:
          errJson = _context4.sent;
          throw errJson;
        case 26:
          _context4.next = 28;
          return response.json();
        case 28:
          cart = _context4.sent;
          _context4.next = 31;
          return fetch("".concat(window.themeVariables.routes.cartUrl, "?section_id=mini-cart"));
        case 31:
          cartSectionResponse = _context4.sent;
          _context4.next = 34;
          return cartSectionResponse.text();
        case 34:
          cartSectionHtml = _context4.sent;
          newDiscounts = cart.discount_codes || [];
          hasNewValidDiscount = newDiscounts.some(function (dc) {
            return dc.applicable;
          });
          invalidCodeRemoved = !hasNewValidDiscount && hasExistingValidDiscount;
          sameCodeRemoved = existingDiscounts.some(function (dc) {
            return dc.code.toLowerCase() === code.toLowerCase() && dc.applicable;
          });
          updateCartUI(cart);
          setTimeout(function () {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: _objectSpread(_objectSpread({}, cart), {}, {
                  sections: {
                    "mini-cart": cartSectionHtml
                  }
                }),
                replacementDelay: 0
              }
            }));
          }, 50);
          if (sameCodeRemoved) {
            showNotification("Rabattcode entfernt", "success");
          } else if (invalidCodeRemoved) {
            showNotification("Ungültiger Rabattcode. Vorheriger Rabatt wurde entfernt.", "error");
          } else if (hasNewValidDiscount) {
            showNotification("Rabattcode erfolgreich angewendet", "success");
          } else {
            showNotification("Ungültiger Rabattcode", "error");
          }
          _context4.next = 47;
          break;
        case 44:
          _context4.prev = 44;
          _context4.t0 = _context4["catch"](8);
          showNotification("Fehler beim Anwenden des Rabattcodes", "error");
        case 47:
          _context4.prev = 47;
          setLoading(false);
          return _context4.finish(47);
        case 50:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[8, 44, 47, 50]]);
  }));
  return _handleCartDiscountApply.apply(this, arguments);
}
document.addEventListener("cart:updated", function (event) {
  var _event$detail;
  if ((_event$detail = event.detail) !== null && _event$detail !== void 0 && _event$detail.cart) {
    updateCartUI(event.detail.cart);
  }
});
document.addEventListener("cart:refresh", function () {
  refreshCart();
});
document.addEventListener("click", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
    var button, removeButton, cartSectionResponse, cartSectionHtml, response, cart;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          button = e.target.closest("#apply-cart-discount");
          if (button) {
            handleCartDiscountApply();
          }
          removeButton = e.target.closest("[data-action='remove-discount']");
          if (!removeButton) {
            _context.next = 31;
            break;
          }
          setLoading(true);
          _context.prev = 5;
          _context.next = 8;
          return fetch("".concat(window.themeVariables.routes.cartUrl, "?section_id=mini-cart"));
        case 8:
          cartSectionResponse = _context.sent;
          _context.next = 11;
          return cartSectionResponse.text();
        case 11:
          cartSectionHtml = _context.sent;
          _context.next = 14;
          return fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              discount_code: ""
            })
          });
        case 14:
          response = _context.sent;
          if (response.ok) {
            _context.next = 17;
            break;
          }
          throw new Error("Network response was not ok");
        case 17:
          _context.next = 19;
          return response.json();
        case 19:
          cart = _context.sent;
          updateCartUI(cart);
          setTimeout(function () {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: _objectSpread(_objectSpread({}, cart), {}, {
                  sections: {
                    "mini-cart": cartSectionHtml
                  }
                }),
                replacementDelay: 0
              }
            }));
          }, 50);
          showNotification("Rabattcode wurde entfernt", "success");
          _context.next = 28;
          break;
        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](5);
          showNotification("Fehler beim Entfernen des Rabattcodes", "error");
        case 28:
          _context.prev = 28;
          setLoading(false);
          return _context.finish(28);
        case 31:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 25, 28, 31]]);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
document.addEventListener("keyup", function (e) {
  if (e.key === "Enter" && e.target.matches("#cart-discount-code")) {
    var _document$getElementB;
    (_document$getElementB = document.getElementById("apply-cart-discount")) === null || _document$getElementB === void 0 || _document$getElementB.click();
  }
});
document.addEventListener("cart-drawer:open", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var response, cart;
  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.prev = 0;
        _context2.next = 3;
        return fetch("/cart.js");
      case 3:
        response = _context2.sent;
        _context2.next = 6;
        return response.json();
      case 6:
        cart = _context2.sent;
        calculateAndDisplaySavings(cart);
        _context2.next = 12;
        break;
      case 10:
        _context2.prev = 10;
        _context2.t0 = _context2["catch"](0);
      case 12:
      case "end":
        return _context2.stop();
    }
  }, _callee2, null, [[0, 10]]);
})));

/***/ }),

/***/ "./src/js/modules/collection-hydration/CollectionHydrationManager.js":
/*!***************************************************************************!*\
  !*** ./src/js/modules/collection-hydration/CollectionHydrationManager.js ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CollectionHydrationManager: () => (/* binding */ CollectionHydrationManager)
/* harmony export */ });
/* harmony import */ var _reviews_io_hydration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./reviews-io-hydration */ "./src/js/modules/collection-hydration/reviews-io-hydration.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/**
 * Manages collection page main section hydration and Reviews.io integration
 */
var CollectionHydrationManager = /*#__PURE__*/function () {
  function CollectionHydrationManager() {
    _classCallCheck(this, CollectionHydrationManager);
    this.bannerSection = document.querySelector(".shopify-section--collection-banner");
    this.mainSection = document.querySelector(".shopify-section--main-collection");
    this.storiesWrapper = document.querySelector(".stories-wrapper");
    this.pending = false;
    this.reviewsManager = new _reviews_io_hydration__WEBPACK_IMPORTED_MODULE_0__.ReviewsIoManager();
    this.bindEvents();
  }
  return _createClass(CollectionHydrationManager, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this$storiesWrapper,
        _this = this;
      (_this$storiesWrapper = this.storiesWrapper) === null || _this$storiesWrapper === void 0 || _this$storiesWrapper.addEventListener("click", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
          var link;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                link = event.target.closest("a[href^='/collections/']");
                if (!(!link || !_this.isValidCollectionLink(link))) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                event.preventDefault();
                _context.next = 6;
                return _this.handleCollectionNavigation(link.href);
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      document.addEventListener("click", /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
          var link;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                link = event.target.closest(".pagination__item[href]");
                if (!(!link || _this.pending)) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return");
              case 3:
                event.preventDefault();
                _context2.next = 6;
                return _this.handleCollectionNavigation(link.href);
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
      window.addEventListener("collection:filter", /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
          var url;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                url = event.detail.url;
                if (!(!url || _this.pending)) {
                  _context3.next = 3;
                  break;
                }
                return _context3.abrupt("return");
              case 3:
                _context3.next = 5;
                return _this.handleCollectionNavigation(url);
              case 5:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "isValidCollectionLink",
    value: function isValidCollectionLink(link) {
      if (!(link !== null && link !== void 0 && link.href) || this.pending) return false;
      if (link.hasAttribute("data-modal-trigger") || link.hasAttribute("data-product-link")) {
        return false;
      }
      return true;
    }
  }, {
    key: "updateActiveStoryLink",
    value: function updateActiveStoryLink(url) {
      if (!this.storiesWrapper) return;
      var path = new URL(url).pathname;
      this.storiesWrapper.querySelectorAll(".story-link").forEach(function (link) {
        var linkPath = new URL(link.href).pathname;
        if (linkPath === path) {
          link.classList.add("activelink");
        } else {
          link.classList.remove("activelink");
        }
      });
    }
  }, {
    key: "handleCollectionNavigation",
    value: function () {
      var _handleCollectionNavigation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(url) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.pending) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              this.pending = true;
              _context4.prev = 3;
              window.history.pushState({}, "", url);
              _context4.next = 7;
              return Promise.all([this.hydrateSection(url, this.bannerSection), this.hydrateSection(url, this.mainSection)]);
            case 7:
              this.updateActiveStoryLink(url);
              window.dispatchEvent(new CustomEvent("collection:updated"));
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](3);
              window.location.href = url;
            case 14:
              _context4.prev = 14;
              this.pending = false;
              return _context4.finish(14);
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 11, 14, 17]]);
      }));
      function handleCollectionNavigation(_x4) {
        return _handleCollectionNavigation.apply(this, arguments);
      }
      return handleCollectionNavigation;
    }()
  }, {
    key: "hydrateSection",
    value: function () {
      var _hydrateSection = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(url, container) {
        var sectionId, response, html;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (container !== null && container !== void 0 && container.id) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return", false);
            case 2:
              sectionId = container.id.replace("shopify-section-", "");
              _context5.prev = 3;
              _context5.next = 6;
              return fetch("".concat(url, "?section_id=").concat(sectionId));
            case 6:
              response = _context5.sent;
              if (response.ok) {
                _context5.next = 9;
                break;
              }
              throw new Error("Failed to fetch section ".concat(sectionId, ": ").concat(response.statusText));
            case 9:
              _context5.next = 11;
              return response.text();
            case 11:
              html = _context5.sent;
              container.innerHTML = html;
              return _context5.abrupt("return", true);
            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5["catch"](3);
              throw _context5.t0;
            case 19:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[3, 16]]);
      }));
      function hydrateSection(_x5, _x6) {
        return _hydrateSection.apply(this, arguments);
      }
      return hydrateSection;
    }()
  }]);
}();

/***/ }),

/***/ "./src/js/modules/collection-hydration/index.js":
/*!******************************************************!*\
  !*** ./src/js/modules/collection-hydration/index.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   collectionHydrationManager: () => (/* binding */ manager),
/* harmony export */   initCollectionHydration: () => (/* binding */ initCollectionHydration)
/* harmony export */ });
/* harmony import */ var _CollectionHydrationManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CollectionHydrationManager */ "./src/js/modules/collection-hydration/CollectionHydrationManager.js");

var initialized = false;
var manager = null;
function initCollectionHydration() {
  if (initialized) return;
  var bannerSection = document.querySelector(".shopify-section--collection-banner");
  var mainSection = document.querySelector(".shopify-section--main-collection");
  var storiesWrapper = document.querySelector(".stories-wrapper");
  if (!bannerSection || !mainSection || !storiesWrapper) {
    return;
  }
  try {
    manager = new _CollectionHydrationManager__WEBPACK_IMPORTED_MODULE_0__.CollectionHydrationManager();
    initialized = true;
  } catch (error) {
    // silent fail
  }
}


/***/ }),

/***/ "./src/js/modules/collection-hydration/reviews-io-hydration.js":
/*!*********************************************************************!*\
  !*** ./src/js/modules/collection-hydration/reviews-io-hydration.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ReviewsIoManager: () => (/* binding */ ReviewsIoManager)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Manages Reviews.io script loading for Collection Pages and Product Detail Pages
 */
var ReviewsIoManager = /*#__PURE__*/function () {
  function ReviewsIoManager() {
    _classCallCheck(this, ReviewsIoManager);
    this.scriptLoaded = false;
    this.scriptLoading = false;
    this.loadScripts();
  }

  /**
   * Loads Reviews.io scripts once
   */
  return _createClass(ReviewsIoManager, [{
    key: "loadScripts",
    value: (function () {
      var _loadScripts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.scriptLoaded || this.scriptLoading)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              this.scriptLoading = true;
              _context.prev = 3;
              _context.next = 6;
              return Promise.all([this.loadScript("https://widget.reviews.io/core-snippet/dist.js"), this.loadScript("https://widget.reviews.io/rating-snippet/dist.js")]);
            case 6:
              this.scriptLoaded = true;
              _context.next = 11;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
            case 11:
              _context.prev = 11;
              this.scriptLoading = false;
              return _context.finish(11);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 9, 11, 14]]);
      }));
      function loadScripts() {
        return _loadScripts.apply(this, arguments);
      }
      return loadScripts;
    }()
    /**
     * Loads a single script
     */
    )
  }, {
    key: "loadScript",
    value: function loadScript(src) {
      return new Promise(function (resolve) {
        var script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.defer = true;
        script.onload = function () {
          resolve();
        };
        script.onerror = function () {
          resolve();
        };
        document.head.appendChild(script);
      });
    }
  }]);
}();

/***/ }),

/***/ "./src/js/modules/product-group/HydrationManager.js":
/*!**********************************************************!*\
  !*** ./src/js/modules/product-group/HydrationManager.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HydrationManager: () => (/* binding */ HydrationManager)
/* harmony export */ });
/* harmony import */ var _hydration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./hydration */ "./src/js/modules/product-group/hydration.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/**
 * Orchestrates communication and sequencing between ProductGroup and section hydration
 */
var HydrationManager = /*#__PURE__*/function () {
  function HydrationManager(_ref) {
    var _this = this;
    var container = _ref.container,
      productGroup = _ref.productGroup,
      selectors = _ref.selectors;
    _classCallCheck(this, HydrationManager);
    if (productGroup.isInvalid()) {
      container.innerHTML = '<p class="product-group-selectors__message">No variant options available for this product.</p>';
      return;
    }
    this.container = container;
    this.productGroup = productGroup;
    this.selectors = selectors;
    this.events = {};
    this.pending = false;
    this.cache = new Map();
    var currentMediaEl = document.querySelector("product-media");
    this.initialProductHandle = currentMediaEl === null || currentMediaEl === void 0 ? void 0 : currentMediaEl.getAttribute("product-handle");
    this.initialUrlParams = this.getURLParams();
    this._initSelectors();
    window.addEventListener("popstate", function () {
      _this.syncFromURL();
    });
    this.init();
  }
  return _createClass(HydrationManager, [{
    key: "_initSelectors",
    value: function _initSelectors() {
      var _this2 = this;
      this.typeSelect = this.container.querySelector(this.selectors.typeSelector);
      this.flavourSelect = this.container.querySelector(this.selectors.flavourSelector);
      if (!this.typeSelect || !this.flavourSelect) {
        return;
      }
      var typeButtons = this.container.querySelectorAll(".type-option");
      typeButtons.forEach(function (btn) {
        btn.addEventListener("click", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var selectedType, currentFlavour, availableFlavours, fallback;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                selectedType = btn.dataset.typeValue;
                currentFlavour = _this2.flavourSelect.value;
                if (!(!btn.disabled && !btn.classList.contains("type-option--disabled"))) {
                  _context.next = 11;
                  break;
                }
                typeButtons.forEach(function (button) {
                  var isSelected = button.dataset.typeValue === selectedType;
                  button.setAttribute("aria-pressed", isSelected ? "true" : "false");
                  button.classList.toggle("selected", isSelected);
                });
                _this2.typeSelect.value = selectedType;
                _context.next = 7;
                return _this2._populateFlavoursWithAvailability(selectedType);
              case 7:
                _context.next = 9;
                return _this2._updateFlavourAvailability(selectedType);
              case 9:
                if (_this2.productGroup.isCombinationAvailable(selectedType, currentFlavour)) {
                  _this2.flavourSelect.value = currentFlavour;
                  _this2._updateFlavourButtonState(currentFlavour);
                } else {
                  availableFlavours = _this2.productGroup.getAvailableFlavours(selectedType);
                  if (availableFlavours.length > 0) {
                    fallback = availableFlavours[0];
                    _this2.flavourSelect.value = fallback;
                    _this2._updateFlavourButtonState(fallback);
                  }
                }
                _this2._handleSelectionChange();
              case 11:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })));
      });
      var flavourButtons = this.container.querySelectorAll(".flavour-option");
      flavourButtons.forEach(function (btn) {
        btn.addEventListener("click", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var selectedFlavour, currentType;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                selectedFlavour = btn.dataset.flavourValue;
                currentType = _this2.typeSelect.value;
                if (_this2.productGroup.isCombinationAvailable(currentType, selectedFlavour)) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return");
              case 4:
                flavourButtons.forEach(function (button) {
                  var isSelected = button.dataset.flavourValue === selectedFlavour;
                  button.setAttribute("aria-pressed", isSelected ? "true" : "false");
                  button.classList.toggle("selected", isSelected);
                });
                _this2.flavourSelect.value = selectedFlavour;
                _this2._handleSelectionChange();
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })));
      });
      this._updateTypeButtonState(this.typeSelect.value);
      this._updateFlavourButtonState(this.flavourSelect.value);
    }
  }, {
    key: "_updateTypeButtonState",
    value: function () {
      var _updateTypeButtonState2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(selectedType) {
        var typeButtons, currentFlavour, _iterator, _step, btn, type, isSelected, _yield$this$_checkAva, isAvailable, isProductAvailable;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              typeButtons = this.container.querySelectorAll(".type-option");
              currentFlavour = this.flavourSelect.value;
              _iterator = _createForOfIteratorHelper(typeButtons);
              _context3.prev = 3;
              _iterator.s();
            case 5:
              if ((_step = _iterator.n()).done) {
                _context3.next = 21;
                break;
              }
              btn = _step.value;
              type = btn.dataset.typeValue;
              isSelected = type === selectedType;
              _context3.next = 11;
              return this._checkAvailability(type, currentFlavour);
            case 11:
              _yield$this$_checkAva = _context3.sent;
              isAvailable = _yield$this$_checkAva.isAvailable;
              isProductAvailable = _yield$this$_checkAva.isProductAvailable;
              btn.disabled = !isAvailable;
              btn.classList.toggle("type-option--disabled", !isAvailable);
              btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
              btn.classList.toggle("selected", isSelected);
              if (!isAvailable || !isProductAvailable) {
                btn.title = !isProductAvailable ? "Sold Out" : "Not available for this flavour";
              } else {
                btn.title = "";
              }
            case 19:
              _context3.next = 5;
              break;
            case 21:
              _context3.next = 26;
              break;
            case 23:
              _context3.prev = 23;
              _context3.t0 = _context3["catch"](3);
              _iterator.e(_context3.t0);
            case 26:
              _context3.prev = 26;
              _iterator.f();
              return _context3.finish(26);
            case 29:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[3, 23, 26, 29]]);
      }));
      function _updateTypeButtonState(_x) {
        return _updateTypeButtonState2.apply(this, arguments);
      }
      return _updateTypeButtonState;
    }()
  }, {
    key: "_updateFlavourButtonState",
    value: function _updateFlavourButtonState(selectedFlavour) {
      var flavourButtons = this.container.querySelectorAll(".flavour-option");
      flavourButtons.forEach(function (btn) {
        var isSelected = btn.dataset.flavourValue === selectedFlavour;
        btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
        btn.classList.toggle("selected", isSelected);
      });
    }
  }, {
    key: "_handleSelectionChange",
    value: function _handleSelectionChange() {
      var type = this.typeSelect.value;
      var flavour = this.flavourSelect.value;
      var product = this.productGroup.getProduct(type, flavour);
      if (product) {
        this.handleProductChange(product);
      }
    }
  }, {
    key: "_populateOptions",
    value: function _populateOptions(select, options, context, isValid) {
      var _this3 = this;
      select.innerHTML = "";
      options.forEach(function (option) {
        var opt = document.createElement("option");
        opt.value = option;
        opt.textContent = _this3._formatLabel(option);
        opt.disabled = !isValid(option, context);
        select.appendChild(opt);
      });
    }
  }, {
    key: "_checkAvailability",
    value: function () {
      var _checkAvailability2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(type, flavour, productHandle) {
        var isAvailable, product, isProductAvailable, response, productData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              isAvailable = this.productGroup.isCombinationAvailable(type, flavour);
              product = this.productGroup.getProduct(type, flavour);
              isProductAvailable = true;
              if (!productHandle) {
                _context4.next = 17;
                break;
              }
              _context4.prev = 4;
              _context4.next = 7;
              return fetch("/products/".concat(productHandle, ".js"));
            case 7:
              response = _context4.sent;
              if (!response.ok) {
                _context4.next = 13;
                break;
              }
              _context4.next = 11;
              return response.json();
            case 11:
              productData = _context4.sent;
              isProductAvailable = productData.available;
            case 13:
              _context4.next = 17;
              break;
            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](4);
            case 17:
              return _context4.abrupt("return", {
                isAvailable: isAvailable,
                isProductAvailable: isProductAvailable
              });
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4, 15]]);
      }));
      function _checkAvailability(_x2, _x3, _x4) {
        return _checkAvailability2.apply(this, arguments);
      }
      return _checkAvailability;
    }()
  }, {
    key: "_populateFlavoursWithAvailability",
    value: function () {
      var _populateFlavoursWithAvailability2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(type) {
        var _this4 = this;
        var flavours, flavourButtons, flavourOptions;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              flavours = this.productGroup.getFlavoursForType(type);
              flavourButtons = this.container.querySelectorAll(".flavour-option");
              flavourButtons.forEach(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(btn) {
                  var flavour, product, _yield$_this4$_checkA, isAvailable, isProductAvailable;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        flavour = btn.dataset.flavourValue;
                        product = _this4.productGroup.getProduct(type, flavour);
                        if (product) {
                          _context5.next = 6;
                          break;
                        }
                        btn.disabled = true;
                        btn.classList.add("flavour-option--disabled");
                        return _context5.abrupt("return");
                      case 6:
                        _context5.next = 8;
                        return _this4._checkAvailability(type, flavour, product.handle);
                      case 8:
                        _yield$_this4$_checkA = _context5.sent;
                        isAvailable = _yield$_this4$_checkA.isAvailable;
                        isProductAvailable = _yield$_this4$_checkA.isProductAvailable;
                        btn.disabled = !isAvailable;
                        btn.classList.toggle("flavour-option--disabled", !isAvailable);
                        if (!isAvailable || !isProductAvailable) {
                          btn.title = !isProductAvailable ? "Sold Out" : "Not available for this size";
                        } else {
                          btn.title = "";
                        }
                      case 14:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x6) {
                  return _ref4.apply(this, arguments);
                };
              }());
              _context7.next = 5;
              return Promise.all(flavours.map(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(flavour) {
                  var product, _yield$_this4$_checkA2, isAvailable, isProductAvailable;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        product = _this4.productGroup.getProduct(type, flavour);
                        if (product) {
                          _context6.next = 3;
                          break;
                        }
                        return _context6.abrupt("return", null);
                      case 3:
                        _context6.next = 5;
                        return _this4._checkAvailability(type, flavour, product.handle);
                      case 5:
                        _yield$_this4$_checkA2 = _context6.sent;
                        isAvailable = _yield$_this4$_checkA2.isAvailable;
                        isProductAvailable = _yield$_this4$_checkA2.isProductAvailable;
                        return _context6.abrupt("return", {
                          value: flavour,
                          label: _this4._formatLabel(flavour),
                          disabled: !isAvailable || !isProductAvailable
                        });
                      case 9:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x7) {
                  return _ref5.apply(this, arguments);
                };
              }()));
            case 5:
              flavourOptions = _context7.sent;
              this.flavourSelect.innerHTML = flavourOptions.filter(Boolean).map(function (opt) {
                return "\n\t\t\t\t\t<option \n\t\t\t\t\t\tvalue=\"".concat(opt.value, "\"\n\t\t\t\t\t\t").concat(opt.disabled ? "disabled" : "", ">\n\t\t\t\t\t\t").concat(opt.label, "\n\t\t\t\t\t</option>\n\t\t\t\t");
              }).join("");
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function _populateFlavoursWithAvailability(_x5) {
        return _populateFlavoursWithAvailability2.apply(this, arguments);
      }
      return _populateFlavoursWithAvailability;
    }()
  }, {
    key: "_updateFlavourAvailability",
    value: function () {
      var _updateFlavourAvailability2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(type) {
        var _this5 = this;
        var buttons;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              buttons = this.container.querySelectorAll(".flavour-option");
              _context9.next = 3;
              return Promise.all(Array.from(buttons).map(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(btn) {
                  var flavour, productHandle, _yield$_this5$_checkA, isAvailable, isProductAvailable, showSoldOut, badge;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        flavour = btn.dataset.flavourValue;
                        productHandle = btn.dataset.productHandle;
                        _context8.next = 4;
                        return _this5._checkAvailability(type, flavour, productHandle);
                      case 4:
                        _yield$_this5$_checkA = _context8.sent;
                        isAvailable = _yield$_this5$_checkA.isAvailable;
                        isProductAvailable = _yield$_this5$_checkA.isProductAvailable;
                        showSoldOut = !isAvailable || !isProductAvailable;
                        btn.classList.toggle("flavour-option--disabled", showSoldOut);
                        btn.setAttribute("aria-disabled", showSoldOut);
                        btn.disabled = showSoldOut;
                        if (!isAvailable) {
                          btn.setAttribute("title", "Not available for this size");
                        } else if (!isProductAvailable) {
                          btn.setAttribute("title", "Sold Out");
                        } else {
                          btn.removeAttribute("title");
                        }
                        badge = btn.querySelector(".flavour-soldout-badge");
                        if (badge) {
                          if (showSoldOut) {
                            badge.textContent = !isAvailable ? "Not Available" : "Sold Out";
                            badge.style.display = "block";
                          } else {
                            badge.style.display = "none";
                          }
                        }
                      case 14:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x9) {
                  return _ref6.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function _updateFlavourAvailability(_x8) {
        return _updateFlavourAvailability2.apply(this, arguments);
      }
      return _updateFlavourAvailability;
    }()
  }, {
    key: "_populateTypesWithAvailability",
    value: function () {
      var _populateTypesWithAvailability2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(flavour) {
        var _this6 = this;
        var types, typeOptions, typeButtons;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              types = this.productGroup.getUniqueTypes();
              _context12.next = 3;
              return Promise.all(types.map(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(type) {
                  var product, isAvailable, response, productData;
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        if (_this6.productGroup.isCombinationAvailable(type, flavour)) {
                          _context10.next = 2;
                          break;
                        }
                        return _context10.abrupt("return", null);
                      case 2:
                        product = _this6.productGroup.getProduct(type, flavour);
                        if (product) {
                          _context10.next = 5;
                          break;
                        }
                        return _context10.abrupt("return", null);
                      case 5:
                        isAvailable = true;
                        _context10.prev = 6;
                        _context10.next = 9;
                        return fetch("/products/".concat(product.handle, ".js"));
                      case 9:
                        response = _context10.sent;
                        if (!response.ok) {
                          _context10.next = 15;
                          break;
                        }
                        _context10.next = 13;
                        return response.json();
                      case 13:
                        productData = _context10.sent;
                        isAvailable = productData.available;
                      case 15:
                        _context10.next = 19;
                        break;
                      case 17:
                        _context10.prev = 17;
                        _context10.t0 = _context10["catch"](6);
                      case 19:
                        return _context10.abrupt("return", "<option value=\"".concat(type, "\" ").concat(!isAvailable ? "disabled" : "", ">").concat(type).concat(!isAvailable ? " (Sold Out)" : "", "</option>"));
                      case 20:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10, null, [[6, 17]]);
                }));
                return function (_x11) {
                  return _ref7.apply(this, arguments);
                };
              }()));
            case 3:
              typeOptions = _context12.sent;
              this.typeSelect.innerHTML = typeOptions.filter(Boolean).join("");
              typeButtons = this.container.querySelectorAll(".type-option");
              typeButtons.forEach(/*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(btn) {
                  var type, product, _yield$_this6$_checkA, isAvailable, isProductAvailable, isDisabled, overlay, _overlay;
                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        type = btn.dataset.typeValue;
                        product = _this6.productGroup.getProduct(type, flavour);
                        if (product) {
                          _context11.next = 8;
                          break;
                        }
                        btn.disabled = true;
                        btn.classList.add("type-option--disabled");
                        btn.setAttribute("aria-disabled", "true");
                        btn.setAttribute("tabindex", "-1");
                        return _context11.abrupt("return");
                      case 8:
                        _context11.next = 10;
                        return _this6._checkAvailability(type, flavour, product.handle);
                      case 10:
                        _yield$_this6$_checkA = _context11.sent;
                        isAvailable = _yield$_this6$_checkA.isAvailable;
                        isProductAvailable = _yield$_this6$_checkA.isProductAvailable;
                        isDisabled = !isAvailable || !isProductAvailable;
                        btn.disabled = isDisabled;
                        btn.classList.toggle("type-option--disabled", isDisabled);
                        btn.setAttribute("aria-disabled", isDisabled);
                        btn.setAttribute("tabindex", isDisabled ? "-1" : "0");
                        if (isDisabled) {
                          btn.title = !isProductAvailable ? "Sold Out" : "Not available for this flavour";
                          overlay = btn.querySelector(".type-soldout-overlay");
                          if (!overlay) {
                            overlay = document.createElement("div");
                            overlay.className = "type-soldout-overlay";
                            btn.appendChild(overlay);
                          }
                        } else {
                          btn.title = "";
                          _overlay = btn.querySelector(".type-soldout-overlay");
                          if (_overlay) {
                            btn.removeChild(_overlay);
                          }
                        }
                      case 19:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                return function (_x12) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function _populateTypesWithAvailability(_x10) {
        return _populateTypesWithAvailability2.apply(this, arguments);
      }
      return _populateTypesWithAvailability;
    }()
  }, {
    key: "_formatLabel",
    value: function _formatLabel(value) {
      return value.replace(/_/g, " ").replace(/\b\w/g, function (l) {
        return l.toUpperCase();
      });
    }
  }, {
    key: "getURLParams",
    value: function getURLParams() {
      var params = new URLSearchParams(window.location.search);
      return {
        type: params.get("type"),
        flavour: params.get("flavour")
      };
    }
  }, {
    key: "shouldHydrateInitialProduct",
    value: function shouldHydrateInitialProduct() {
      if (!this.initialProductHandle) return true;
      var _this$initialUrlParam = this.initialUrlParams,
        type = _this$initialUrlParam.type,
        flavour = _this$initialUrlParam.flavour;
      if (type && flavour && this.productGroup.isValidCombination(type, flavour)) {
        var intendedProduct = this.productGroup.getProduct(type, flavour);
        return (intendedProduct === null || intendedProduct === void 0 ? void 0 : intendedProduct.handle) !== this.initialProductHandle;
      }
      if (this.productGroup.loadStoredSelections()) {
        var storedProduct = this.productGroup.getCurrentProduct();
        return (storedProduct === null || storedProduct === void 0 ? void 0 : storedProduct.handle) !== this.initialProductHandle;
      }
      var currentProduct = this.productGroup.getCurrentProduct();
      return (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.handle) !== this.initialProductHandle;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this$initialUrlParam2, type, flavour, product, _current, current;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this._populateTypesWithAvailability(this.productGroup.state.currentFlavour);
            case 2:
              _context13.next = 4;
              return this._populateFlavoursWithAvailability(this.productGroup.state.currentType);
            case 4:
              _context13.next = 6;
              return this._updateFlavourAvailability(this.productGroup.state.currentType);
            case 6:
              this.typeSelect.value = this.productGroup.state.currentType;
              this.flavourSelect.value = this.productGroup.state.currentFlavour;
              this._updateFlavourButtonState(this.flavourSelect.value);
              if (this.shouldHydrateInitialProduct()) {
                _context13.next = 11;
                break;
              }
              return _context13.abrupt("return");
            case 11:
              _this$initialUrlParam2 = this.initialUrlParams, type = _this$initialUrlParam2.type, flavour = _this$initialUrlParam2.flavour;
              if (!(type && flavour && this.productGroup.isValidCombination(type, flavour))) {
                _context13.next = 19;
                break;
              }
              product = this.productGroup.getProduct(type, flavour);
              if (!product) {
                _context13.next = 19;
                break;
              }
              this.productGroup.updateSelection(type, flavour);
              this._updateFlavourButtonState(flavour);
              this.handleProductChange(product);
              return _context13.abrupt("return");
            case 19:
              if (!this.productGroup.loadStoredSelections()) {
                _context13.next = 25;
                break;
              }
              _current = this.productGroup.getCurrentProduct();
              if (!_current) {
                _context13.next = 25;
                break;
              }
              this._updateFlavourButtonState(_current.flavour);
              this.handleProductChange(_current);
              return _context13.abrupt("return");
            case 25:
              current = this.productGroup.getCurrentProduct();
              if (current) {
                this._updateFlavourButtonState(current.flavour);
                this.updateURL(current.handle, current.type, current.flavour);
              }
            case 27:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "syncFromURL",
    value: function () {
      var _syncFromURL = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this$getURLParams, type, flavour, product;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this$getURLParams = this.getURLParams(), type = _this$getURLParams.type, flavour = _this$getURLParams.flavour;
              if (!(type && flavour && this.productGroup.isValidCombination(type, flavour))) {
                _context14.next = 12;
                break;
              }
              product = this.productGroup.getProduct(type, flavour);
              if (!product) {
                _context14.next = 12;
                break;
              }
              this.productGroup.updateSelection(type, flavour);
              _context14.next = 7;
              return this._populateTypesWithAvailability(flavour);
            case 7:
              _context14.next = 9;
              return this._populateFlavoursWithAvailability(type);
            case 9:
              this.typeSelect.value = type;
              this.flavourSelect.value = flavour;
              this.handleProductChange(product);
            case 12:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function syncFromURL() {
        return _syncFromURL.apply(this, arguments);
      }
      return syncFromURL;
    }()
  }, {
    key: "handleProductChange",
    value: function () {
      var _handleProductChange = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(product) {
        var sectionInput, mainSectionId, contentTabsSection, contentTabsSectionId, sectionsToHydrate, selectedButton, imageWrapper, data, res, _yield$hydrateSection, success, results, _selectedButton, _imageWrapper;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!(!product || !product.handle || this.pending)) {
                _context15.next = 2;
                break;
              }
              return _context15.abrupt("return");
            case 2:
              this.pending = true;
              _context15.prev = 3;
              if (product.handle) {
                _context15.next = 6;
                break;
              }
              return _context15.abrupt("return");
            case 6:
              // Get main section ID
              sectionInput = document.querySelector('input[name="section-id"]');
              mainSectionId = (sectionInput === null || sectionInput === void 0 ? void 0 : sectionInput.value) || "main-product"; // Get content tabs section ID
              contentTabsSection = document.querySelector(".shopify-section--product-content");
              contentTabsSectionId = contentTabsSection === null || contentTabsSection === void 0 ? void 0 : contentTabsSection.id.replace("shopify-section-", "");
              sectionsToHydrate = [mainSectionId];
              if (contentTabsSectionId) {
                sectionsToHydrate.push(contentTabsSectionId);
              }
              this.emit("productFetchStart", product);
              selectedButton = this.container.querySelector(".flavour-option[data-flavour-value=\"".concat(product.flavour, "\"]"));
              if (selectedButton) {
                imageWrapper = selectedButton.querySelector(".flavour-image-wrapper");
                if (imageWrapper) {
                  imageWrapper.classList.add("is-loading");
                }
              }
              data = this.cache.get(product.handle);
              if (data) {
                _context15.next = 27;
                break;
              }
              _context15.next = 19;
              return fetch("/products/".concat(product.handle, ".js"));
            case 19:
              res = _context15.sent;
              if (res.ok) {
                _context15.next = 22;
                break;
              }
              throw new Error("Failed to fetch product: ".concat(res.statusText));
            case 22:
              _context15.next = 24;
              return res.json();
            case 24:
              data = _context15.sent;
              this.cache.set(product.handle, data);
              this.emit("productFetchComplete", data);
            case 27:
              _context15.next = 29;
              return (0,_hydration__WEBPACK_IMPORTED_MODULE_0__.hydrateSections)(product.handle, sectionsToHydrate);
            case 29:
              _yield$hydrateSection = _context15.sent;
              success = _yield$hydrateSection.success;
              results = _yield$hydrateSection.results;
              if (success) {
                _context15.next = 35;
                break;
              }
              if (results[mainSectionId]) {
                _context15.next = 35;
                break;
              }
              throw new Error("Failed to hydrate main section");
            case 35:
              this.productGroup.updateSelection(product.type, product.flavour);
              this.updateURL(product.handle, product.type, product.flavour);
              _context15.next = 39;
              return (0,_hydration__WEBPACK_IMPORTED_MODULE_0__.reinitializeProductGroup)();
            case 39:
              this.emit("productHydrationSuccess", product);
              _context15.next = 46;
              break;
            case 42:
              _context15.prev = 42;
              _context15.t0 = _context15["catch"](3);
              this.emit("productHydrationError", _context15.t0);
              if (product.url) window.location.href = product.url;
            case 46:
              _context15.prev = 46;
              _selectedButton = this.container.querySelector(".flavour-option[data-flavour-value=\"".concat(product.flavour, "\"]"));
              if (_selectedButton) {
                _imageWrapper = _selectedButton.querySelector(".flavour-image-wrapper");
                if (_imageWrapper) {
                  _imageWrapper.classList.remove("is-loading");
                }
              }
              this.pending = false;
              return _context15.finish(46);
            case 51:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this, [[3, 42, 46, 51]]);
      }));
      function handleProductChange(_x13) {
        return _handleProductChange.apply(this, arguments);
      }
      return handleProductChange;
    }()
  }, {
    key: "updateURL",
    value: function updateURL(handle, type, flavour) {
      if (!handle) return;
      var searchParams = new URLSearchParams();
      if (type) searchParams.set("type", type);
      if (flavour) searchParams.set("flavour", flavour);
      var newUrl = "/products/".concat(handle).concat(searchParams.toString() ? "?".concat(searchParams) : "");
      var state = {
        handle: handle,
        type: type,
        flavour: flavour,
        timestamp: Date.now()
      };
      window.history.pushState(state, "", newUrl);
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      var _this$events, _this$events$event;
      (_this$events$event = (_this$events = this.events)[event]) !== null && _this$events$event !== void 0 ? _this$events$event : _this$events[event] = [];
      this.events[event].push(callback);
    }
  }, {
    key: "emit",
    value: function emit(event, data) {
      (this.events[event] || []).forEach(function (cb) {
        return cb(data);
      });
    }
  }]);
}();

/***/ }),

/***/ "./src/js/modules/product-group/ProductGroup.js":
/*!******************************************************!*\
  !*** ./src/js/modules/product-group/ProductGroup.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ProductGroup: () => (/* binding */ ProductGroup)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils */ "./src/js/modules/product-group/utils.js");
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./storage */ "./src/js/modules/product-group/storage.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



/**
 * Core ProductGroup class that manages product group data and state
 */
var ProductGroup = /*#__PURE__*/function () {
  function ProductGroup(groupData) {
    _classCallCheck(this, ProductGroup);
    if (!groupData || !(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidGroupId)(groupData.groupId)) {
      this._isInvalid = true;
      return;
    }
    this.groupId = groupData.groupId;
    this.currentProduct = groupData.currentProduct;
    this.variantType = groupData.variantType;
    this.variantFlavour = groupData.variantFlavour;
    this.groupedProducts = groupData.groupedProducts || [];
    this.allGroupHandles = groupData.allGroupHandles || [];
    this.combinations = new Map();
    this.types = new Set();
    this.flavours = new Set();
    if (!Array.isArray(this.groupedProducts) || this.groupedProducts.length === 0) {
      this._isInvalid = true;
      return;
    }
    this.state = {
      currentType: this.variantType || "None",
      currentFlavour: this.variantFlavour || "None",
      isLoading: false
    };
    this._callbacks = new Set();
    this._buildCombinationsMap();
  }
  return _createClass(ProductGroup, [{
    key: "_normalizeString",
    value: function _normalizeString(str) {
      return (str || "").trim().toLowerCase().replace(/\s+/g, " ");
    }
  }, {
    key: "_buildCombinationsMap",
    value: function _buildCombinationsMap() {
      var _this = this;
      this.groupedProducts.forEach(function (product) {
        if (!product || !(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidType)(product.type) || !(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidFlavour)(product.flavour)) {
          return;
        }
        var normalizedType = _this._normalizeString(product.type);
        if (!_this.combinations.has(normalizedType)) {
          _this.combinations.set(normalizedType, {
            flavours: new Set(),
            products: []
          });
        }
        _this.combinations.get(normalizedType).products.push(product);
        _this.combinations.get(normalizedType).flavours.add(product.flavour);
        _this.types.add(normalizedType);
        _this.flavours.add(product.flavour);
      });
      this.types = Array.from(this.types).sort();
      this.flavours = Array.from(this.flavours).sort();
    }
  }, {
    key: "getUniqueTypes",
    value: function getUniqueTypes() {
      var _this2 = this;
      var uniqueTypes = new Set(this.groupedProducts.map(function (p) {
        return _this2._normalizeString(p.type);
      }).filter(Boolean));
      return Array.from(uniqueTypes).sort();
    }
  }, {
    key: "getTypesForFlavour",
    value: function getTypesForFlavour(flavour) {
      var _this3 = this;
      if (!(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidFlavour)(flavour)) return [];
      var normalizedFlavour = this._normalizeString(flavour);
      var types = this.groupedProducts.filter(function (p) {
        return _this3._normalizeString(p.flavour) === normalizedFlavour;
      }).map(function (p) {
        return _this3._normalizeString(p.type);
      }).filter(Boolean);
      return _toConsumableArray(new Set(types)).sort();
    }
  }, {
    key: "getTypes",
    value: function getTypes() {
      return this.getUniqueTypes();
    }
  }, {
    key: "getFlavours",
    value: function getFlavours() {
      return this.flavours;
    }
  }, {
    key: "getAvailableFlavours",
    value: function getAvailableFlavours(type) {
      if (!(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidType)(type)) return [];
      var combination = this.combinations.get(type);
      return combination ? Array.from(combination.flavours).sort() : [];
    }
  }, {
    key: "getFlavoursForType",
    value: function getFlavoursForType(type) {
      return this.getAvailableFlavours(type);
    }
  }, {
    key: "isCombinationAvailable",
    value: function isCombinationAvailable(type, flavour) {
      if (!(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidType)(type) || !(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidFlavour)(flavour)) return false;
      if (!this.combinations.has(type)) return false;
      return this.combinations.get(type).flavours.has(flavour);
    }
  }, {
    key: "getProduct",
    value: function getProduct(type, flavour) {
      if (!(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidType)(type) || !(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidFlavour)(flavour)) return null;
      var combination = this.combinations.get(type);
      if (!combination) return null;
      return combination.products.find(function (p) {
        return p.flavour === flavour;
      }) || null;
    }
  }, {
    key: "getAllProducts",
    value: function getAllProducts() {
      return this.groupedProducts;
    }
  }, {
    key: "updateSelection",
    value: function updateSelection(type, flavour) {
      if (!(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidType)(type) || !(0,_utils__WEBPACK_IMPORTED_MODULE_0__.isValidFlavour)(flavour)) {
        return;
      }
      this.state.currentType = type;
      this.state.currentFlavour = flavour;
      (0,_storage__WEBPACK_IMPORTED_MODULE_1__.storeSelections)(this.groupId, {
        lastSelectedType: type,
        lastSelectedFlavour: flavour
      }, this.currentProduct);
      this.currentProduct = this.getProduct(type, flavour);
      this._callbacks.forEach(function (callback) {
        return callback({
          type: type,
          flavour: flavour
        });
      });
    }
  }, {
    key: "getCurrentProduct",
    value: function getCurrentProduct() {
      return this.getProduct(this.state.currentType, this.state.currentFlavour);
    }
  }, {
    key: "loadStoredSelections",
    value: function loadStoredSelections() {
      var stored = (0,_storage__WEBPACK_IMPORTED_MODULE_1__.getSelections)(this.groupId, this.currentProduct);
      if (stored) {
        var product = this.getProduct(stored.lastSelectedType, stored.lastSelectedFlavour);
        if (product) {
          this.updateSelection(stored.lastSelectedType, stored.lastSelectedFlavour);
          return true;
        }
      }
      return false;
    }
  }, {
    key: "isValidCombination",
    value: function isValidCombination(type, flavour) {
      return this.getProduct(type, flavour) !== null;
    }
  }, {
    key: "onSelectionChange",
    value: function onSelectionChange(callback) {
      var _this4 = this;
      if (typeof callback !== "function") {
        return function () {};
      }
      this._callbacks.add(callback);
      return function () {
        return _this4._callbacks["delete"](callback);
      };
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var urlParams = new URLSearchParams(window.location.search);
      var urlType = urlParams.get("type");
      var urlFlavour = urlParams.get("flavour");
      if (urlType && urlFlavour) {
        var product = this.getProduct(urlType, urlFlavour);
        if (product) {
          this.updateSelection(urlType, urlFlavour);
          return;
        }
      }
      if (this.variantType && this.variantFlavour) {
        var _product = this.getProduct(this.variantType, this.variantFlavour);
        if (_product) {
          this.updateSelection(this.variantType, this.variantFlavour);
          return;
        }
      }
      if (!this.loadStoredSelections()) {
        var firstType = this.types[0];
        if (firstType) {
          var firstFlavour = this.getFlavoursForType(firstType)[0];
          if (firstFlavour) {
            this.updateSelection(firstType, firstFlavour);
          }
        }
      }
    }
  }, {
    key: "isInvalid",
    value: function isInvalid() {
      return !!this._isInvalid;
    }
  }, {
    key: "isTypeAvailable",
    value: function isTypeAvailable(type) {
      return this.groupedProducts.some(function (product) {
        return product.type === type && product.available;
      });
    }
  }, {
    key: "isTypeSoldOut",
    value: function isTypeSoldOut(type) {
      var products = this.groupedProducts.filter(function (product) {
        return product.type === type;
      });
      return !products.some(function (p) {
        return p.available;
      });
    }
  }, {
    key: "getCurrentType",
    value: function getCurrentType() {
      return this.state.currentType;
    }
  }, {
    key: "getCurrentFlavour",
    value: function getCurrentFlavour() {
      return this.state.currentFlavour;
    }
  }]);
}();

/***/ }),

/***/ "./src/js/modules/product-group/ProductGroupModal.js":
/*!***********************************************************!*\
  !*** ./src/js/modules/product-group/ProductGroupModal.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ProductGroupModal: () => (/* binding */ ProductGroupModal)
/* harmony export */ });
/* harmony import */ var _ProductGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ProductGroup */ "./src/js/modules/product-group/ProductGroup.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var ProductGroupModal = /*#__PURE__*/function (_HTMLElement) {
  function ProductGroupModal() {
    var _this;
    _classCallCheck(this, ProductGroupModal);
    _this = _callSuper(this, ProductGroupModal);
    _this.productGroup = null;
    _this.form = _this.querySelector("form");
    _this.closeButton = _this.querySelector("[data-modal-close]");
    _this.overlay = _this.querySelector("[data-modal-overlay]");
    _this.addToCartButton = _this.querySelector("[data-add-to-cart]");
    _this.selectorsContainer = _this.querySelector(".product-group-modal__selectors");
    _this.loadingElement = _this.querySelector(".product-group-modal__loading");
    _this.errorElement = _this.querySelector(".product-group-selectors__error");
    _this.selectorsContent = _this.querySelector(".product-group-selectors__content");
    _this.bindEvents();
    return _this;
  }
  _inherits(ProductGroupModal, _HTMLElement);
  return _createClass(ProductGroupModal, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this$closeButton,
        _this2 = this,
        _this$overlay,
        _this$form;
      (_this$closeButton = this.closeButton) === null || _this$closeButton === void 0 || _this$closeButton.addEventListener("click", function () {
        return _this2.hide();
      });
      (_this$overlay = this.overlay) === null || _this$overlay === void 0 || _this$overlay.addEventListener("click", function () {
        return _this2.hide();
      });
      (_this$form = this.form) === null || _this$form === void 0 || _this$form.addEventListener("submit", this.handleSubmit.bind(this));
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !_this2.hasAttribute("hidden")) {
          _this2.hide();
        }
      });
      var typeSelector = this.querySelector("[data-group-selector='type']");
      if (typeSelector) {
        typeSelector.addEventListener("change", function (event) {
          var type = event.target.value;
          _this2.renderFlavourButtons(type);
        });
      }
    }
  }, {
    key: "updateProductSelection",
    value: function updateProductSelection(type, flavour) {
      if (!this.productGroup) return;
      this.productGroup.updateSelection(type, flavour);
      var product = this.productGroup.getCurrentProduct();
      if (product) {
        var variantInput = this.form.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = product.id;
        }
      }
    }
  }, {
    key: "showLoadingState",
    value: function showLoadingState() {
      if (this.loadingElement) {
        this.loadingElement.removeAttribute("hidden");
        this.loadingElement.classList.add("is-visible");
      }
      if (this.errorElement) {
        this.errorElement.setAttribute("hidden", "");
      }
      if (this.selectorsContent) {
        this.selectorsContent.setAttribute("hidden", "");
      }
    }
  }, {
    key: "hideLoadingState",
    value: function hideLoadingState() {
      var _this3 = this;
      if (this.loadingElement) {
        this.loadingElement.classList.remove("is-visible");
        setTimeout(function () {
          _this3.loadingElement.setAttribute("hidden", "");
        }, 300);
      }
      if (this.selectorsContent) {
        this.selectorsContent.removeAttribute("hidden");
      }
    }
  }, {
    key: "showErrorState",
    value: function showErrorState() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Unable to load product options. Please try again.";
      if (this.errorElement) {
        this.errorElement.innerHTML = "\n\t\t\t\t<p>".concat(message, "</p>\n\t\t\t\t<button class=\"button button--secondary\" onclick=\"this.closest('product-group-modal').retry()\">\n\t\t\t\t\tTry Again\n\t\t\t\t</button>\n\t\t\t");
        this.errorElement.removeAttribute("hidden");
      }
      if (this.loadingElement) {
        this.loadingElement.setAttribute("hidden", "");
      }
      if (this.selectorsContent) {
        this.selectorsContent.setAttribute("hidden", "");
      }
    }
  }, {
    key: "show",
    value: function () {
      var _show = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var productItem, groupDataElement, groupData, invalidProducts, _iterator, _step, product, response, productData, types, firstType, flavours, firstFlavour, currentType;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.removeAttribute("hidden");
              if (this.productGroup) {
                _context.next = 66;
                break;
              }
              productItem = this.closest("product-item");
              if (productItem) {
                _context.next = 6;
                break;
              }
              throw new Error("Product item not found");
            case 6:
              groupDataElement = productItem.querySelector("[data-product-group]");
              if (groupDataElement) {
                _context.next = 9;
                break;
              }
              throw new Error("Product group data not found");
            case 9:
              _context.prev = 9;
              groupData = JSON.parse(groupDataElement.textContent);
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](9);
              throw new Error("Invalid product group data format");
            case 16:
              if (!(!groupData || !Array.isArray(groupData.groupedProducts) || groupData.groupedProducts.length === 0)) {
                _context.next = 18;
                break;
              }
              throw new Error("No available product combinations");
            case 18:
              invalidProducts = groupData.groupedProducts.filter(function (product) {
                return !product.type || !product.handle;
              });
              if (!(invalidProducts.length > 0)) {
                _context.next = 21;
                break;
              }
              throw new Error("Invalid product configuration");
            case 21:
              _iterator = _createForOfIteratorHelper(groupData.groupedProducts);
              _context.prev = 22;
              _iterator.s();
            case 24:
              if ((_step = _iterator.n()).done) {
                _context.next = 43;
                break;
              }
              product = _step.value;
              if (product.id) {
                _context.next = 41;
                break;
              }
              _context.prev = 27;
              _context.next = 30;
              return fetch("/products/".concat(product.handle, ".js"));
            case 30:
              response = _context.sent;
              if (response.ok) {
                _context.next = 33;
                break;
              }
              throw new Error("Failed to fetch product ".concat(product.handle));
            case 33:
              _context.next = 35;
              return response.json();
            case 35:
              productData = _context.sent;
              product.id = productData.variants[0].id;
              _context.next = 41;
              break;
            case 39:
              _context.prev = 39;
              _context.t1 = _context["catch"](27);
            case 41:
              _context.next = 24;
              break;
            case 43:
              _context.next = 48;
              break;
            case 45:
              _context.prev = 45;
              _context.t2 = _context["catch"](22);
              _iterator.e(_context.t2);
            case 48:
              _context.prev = 48;
              _iterator.f();
              return _context.finish(48);
            case 51:
              this.productGroup = new _ProductGroup__WEBPACK_IMPORTED_MODULE_0__.ProductGroup(groupData);
              if (!this.productGroup.isInvalid()) {
                _context.next = 54;
                break;
              }
              throw new Error("Invalid product group configuration");
            case 54:
              this.productGroup.initialize();
              _context.next = 57;
              return this.renderTypeButtons();
            case 57:
              types = this.productGroup.getTypes();
              if (!(types.length > 0)) {
                _context.next = 64;
                break;
              }
              firstType = types[0];
              _context.next = 62;
              return this.renderFlavourButtons(firstType);
            case 62:
              flavours = this.productGroup.getFlavoursForType(firstType);
              if (flavours.length > 0) {
                firstFlavour = flavours[0];
                this.updateProductSelection(firstType, firstFlavour);
              } else {
                this.updateProductSelection(firstType, "");
              }
            case 64:
              _context.next = 72;
              break;
            case 66:
              _context.next = 68;
              return this.renderTypeButtons();
            case 68:
              currentType = this.productGroup.getCurrentType();
              if (!currentType) {
                _context.next = 72;
                break;
              }
              _context.next = 72;
              return this.renderFlavourButtons(currentType);
            case 72:
              this.classList.add("is-visible");
              document.body.style.overflow = "hidden";
              this.hideLoadingState();
              _context.next = 80;
              break;
            case 77:
              _context.prev = 77;
              _context.t3 = _context["catch"](0);
              this.showErrorState(_context.t3.message);
            case 80:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 77], [9, 13], [22, 45, 48, 51], [27, 39]]);
      }));
      function show() {
        return _show.apply(this, arguments);
      }
      return show;
    }()
  }, {
    key: "renderTypeButtons",
    value: function () {
      var _renderTypeButtons = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4 = this;
        var container, hiddenSelect, types;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              container = this.querySelector(".type-options");
              hiddenSelect = this.querySelector("#group-type");
              if (!(!container || !this.productGroup)) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              types = this.productGroup.getTypes();
              container.innerHTML = "";
              hiddenSelect.innerHTML = "";
              _context3.next = 9;
              return Promise.all(types.map(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(type) {
                  var currentFlavour, product, isAvailable, res, data, isSelected, button, typeLabel, option;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        currentFlavour = _this4.productGroup.getCurrentFlavour();
                        product = _this4.productGroup.getProduct(type, currentFlavour);
                        isAvailable = false;
                        if (!product) {
                          _context2.next = 17;
                          break;
                        }
                        _context2.prev = 4;
                        _context2.next = 7;
                        return fetch("/products/".concat(product.handle, ".js"));
                      case 7:
                        res = _context2.sent;
                        if (!res.ok) {
                          _context2.next = 13;
                          break;
                        }
                        _context2.next = 11;
                        return res.json();
                      case 11:
                        data = _context2.sent;
                        isAvailable = data.available;
                      case 13:
                        _context2.next = 17;
                        break;
                      case 15:
                        _context2.prev = 15;
                        _context2.t0 = _context2["catch"](4);
                      case 17:
                        isSelected = type === _this4.productGroup.getCurrentType();
                        button = document.createElement("button");
                        button.type = "button";
                        button.className = "type-option".concat(isSelected ? " selected" : "").concat(!isAvailable ? " type-option--disabled" : "");
                        button.dataset.typeValue = type;
                        button.setAttribute("aria-pressed", isSelected ? "true" : "false");
                        typeLabel = type.replace(/_/g, " ").split(" ").map(function (word) {
                          return word.charAt(0).toUpperCase() + word.slice(1);
                        }).join(" ");
                        button.innerHTML = "\n\t\t\t\t\t<span class=\"type-label\">".concat(typeLabel, "</span>\n\t\t\t\t\t").concat(!isAvailable ? '<div class="type-soldout-overlay"></div>' : "", "\n\t\t\t\t");
                        if (!isAvailable) {
                          button.disabled = true;
                          button.setAttribute("aria-disabled", "true");
                          button.setAttribute("tabindex", "-1");
                          button.title = "Sold Out";
                        } else {
                          button.setAttribute("aria-disabled", "false");
                          button.setAttribute("tabindex", "0");
                          button.title = "";
                          button.addEventListener("click", function () {
                            if (button.classList.contains("selected")) return;
                            var newFlavours = _this4.productGroup.getFlavoursForType(type);
                            var currentFlavour = _this4.productGroup.getCurrentFlavour();
                            var selectedFlavour = newFlavours.includes(currentFlavour) ? currentFlavour : newFlavours[0];
                            _this4.updateProductSelection(type, selectedFlavour);
                            _toConsumableArray(container.querySelectorAll(".type-option")).forEach(function (b) {
                              var isMatch = b.dataset.typeValue === type;
                              b.classList.toggle("selected", isMatch);
                              b.setAttribute("aria-pressed", isMatch ? "true" : "false");
                            });
                            _this4.renderFlavourButtons(type);
                          });
                        }
                        container.appendChild(button);
                        option = document.createElement("option");
                        option.value = type;
                        option.textContent = type;
                        option.selected = isSelected;
                        option.disabled = !isAvailable;
                        hiddenSelect.appendChild(option);
                      case 33:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[4, 15]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function renderTypeButtons() {
        return _renderTypeButtons.apply(this, arguments);
      }
      return renderTypeButtons;
    }()
  }, {
    key: "hide",
    value: function hide() {
      var _this5 = this;
      this.classList.remove("is-visible");
      this.classList.add("is-hidden");
      setTimeout(function () {
        _this5.setAttribute("hidden", "");
        _this5.classList.remove("is-hidden");
        document.body.style.overflow = "";
      }, 300);
    }
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(event) {
        var selectedProduct, formData, response, error, loader;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              event.preventDefault();
              if (this.productGroup) {
                _context4.next = 4;
                break;
              }
              this.showErrorState("Product configuration is not loaded. Please try again.");
              return _context4.abrupt("return");
            case 4:
              selectedProduct = this.productGroup.getCurrentProduct();
              if (selectedProduct) {
                _context4.next = 8;
                break;
              }
              this.showErrorState("Please select a valid product combination.");
              return _context4.abrupt("return");
            case 8:
              this.addToCartButton.disabled = true;
              this.addToCartButton.classList.add("is-loading");
              _context4.prev = 10;
              formData = new FormData(this.form);
              formData.set("id", selectedProduct.id);
              _context4.next = 15;
              return fetch("/cart/add.js", {
                method: "POST",
                body: formData
              });
            case 15:
              response = _context4.sent;
              if (response.ok) {
                _context4.next = 21;
                break;
              }
              _context4.next = 19;
              return response.json();
            case 19:
              error = _context4.sent;
              throw new Error(error.description || "Failed to add product to cart");
            case 21:
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              this.hide();
              _context4.next = 28;
              break;
            case 25:
              _context4.prev = 25;
              _context4.t0 = _context4["catch"](10);
              this.showErrorState(_context4.t0.message);
            case 28:
              _context4.prev = 28;
              this.addToCartButton.disabled = false;
              this.addToCartButton.classList.remove("is-loading");
              loader = this.addToCartButton.querySelector(".button__loader");
              if (loader) {
                loader.remove();
              }
              return _context4.finish(28);
            case 34:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[10, 25, 28, 34]]);
      }));
      function handleSubmit(_x2) {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }, {
    key: "retry",
    value: function retry() {
      this.productGroup = null;
      if (this.loadingElement) {
        this.loadingElement.removeAttribute("hidden");
      }
      if (this.errorElement) {
        this.errorElement.setAttribute("hidden", "");
        this.errorElement.innerHTML = "";
      }
      if (this.selectorsContent) {
        this.selectorsContent.setAttribute("hidden", "");
        this.selectorsContent.querySelectorAll("select").forEach(function (select) {
          select.innerHTML = "";
        });
      }
      this.show();
    }
  }, {
    key: "renderFlavourButtons",
    value: function () {
      var _renderFlavourButtons = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(type) {
        var _this6 = this;
        var container, hiddenSelect, flavours, hasVisibleFlavours, flavourSection;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              container = this.querySelector("[data-group-selector='flavour']:not(select)");
              hiddenSelect = this.querySelector("#group-flavour");
              if (!(!container || !this.productGroup)) {
                _context6.next = 4;
                break;
              }
              return _context6.abrupt("return");
            case 4:
              flavours = this.productGroup.getFlavoursForType(type);
              container.innerHTML = "";
              hiddenSelect.innerHTML = "";
              hasVisibleFlavours = flavours.some(function (flavour) {
                return flavour !== "neutral";
              });
              flavourSection = this.querySelector(".product-group-selectors__flavour");
              if (flavourSection) {
                flavourSection.style.display = hasVisibleFlavours ? "block" : "none";
              }
              if (hasVisibleFlavours) {
                _context6.next = 12;
                break;
              }
              return _context6.abrupt("return");
            case 12:
              _context6.next = 14;
              return Promise.all(flavours.map(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(flavour) {
                  var product, isAvailable, res, data, btn, wrapper, imgWrapper, img, overlay, badge, label, opt;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        product = _this6.productGroup.getProduct(type, flavour);
                        if (product) {
                          _context5.next = 3;
                          break;
                        }
                        return _context5.abrupt("return");
                      case 3:
                        isAvailable = true;
                        _context5.prev = 4;
                        _context5.next = 7;
                        return fetch("/products/".concat(product.handle, ".js"));
                      case 7:
                        res = _context5.sent;
                        if (!res.ok) {
                          _context5.next = 13;
                          break;
                        }
                        _context5.next = 11;
                        return res.json();
                      case 11:
                        data = _context5.sent;
                        isAvailable = data.available;
                      case 13:
                        _context5.next = 17;
                        break;
                      case 15:
                        _context5.prev = 15;
                        _context5.t0 = _context5["catch"](4);
                      case 17:
                        btn = document.createElement("button");
                        btn.type = "button";
                        btn.className = "flavour-option";
                        if (!isAvailable) {
                          btn.classList.add("flavour-option--disabled");
                        }
                        btn.dataset.flavourValue = flavour;
                        btn.dataset.productHandle = product.handle;
                        btn.setAttribute("aria-pressed", "false");
                        btn.setAttribute("title", isAvailable ? flavour : "Sold Out");
                        btn.disabled = !isAvailable;
                        btn.setAttribute("aria-disabled", !isAvailable);
                        btn.setAttribute("tabindex", isAvailable ? "0" : "-1");
                        wrapper = document.createElement("div");
                        wrapper.className = "flavour-option__content";
                        if (product.flavourImage) {
                          imgWrapper = document.createElement("div");
                          imgWrapper.className = "flavour-image-wrapper";
                          img = document.createElement("img");
                          img.src = product.flavourImage;
                          img.alt = flavour;
                          img.width = 80;
                          img.height = 80;
                          img.loading = "lazy";
                          imgWrapper.appendChild(img);
                          if (!isAvailable) {
                            overlay = document.createElement("div");
                            overlay.className = "flavour-overlay";
                            imgWrapper.appendChild(overlay);
                            badge = document.createElement("span");
                            badge.className = "flavour-soldout-badge";
                            badge.textContent = "Sold Out";
                            imgWrapper.appendChild(badge);
                          }
                          wrapper.appendChild(imgWrapper);
                        }
                        label = document.createElement("span");
                        label.className = "flavour-label";
                        label.textContent = flavour.replace(/_/g, " ");
                        wrapper.appendChild(label);
                        btn.appendChild(wrapper);
                        container.appendChild(btn);
                        opt = document.createElement("option");
                        opt.value = flavour;
                        opt.textContent = flavour;
                        opt.disabled = !isAvailable;
                        hiddenSelect.appendChild(opt);
                        btn.addEventListener("click", function () {
                          _this6.updateProductSelection(type, flavour);
                          hiddenSelect.value = flavour;
                          _toConsumableArray(container.querySelectorAll(".flavour-option")).forEach(function (b) {
                            b.classList.toggle("selected", b.dataset.flavourValue === flavour);
                            b.setAttribute("aria-pressed", b.dataset.flavourValue === flavour);
                          });
                        });
                      case 43:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5, null, [[4, 15]]);
                }));
                return function (_x4) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function renderFlavourButtons(_x3) {
        return _renderFlavourButtons.apply(this, arguments);
      }
      return renderFlavourButtons;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("product-group-modal", ProductGroupModal);
customElements.whenDefined("product-group-modal").then(function () {
  var globalLoading = document.createElement("div");
  globalLoading.className = "product-group-modal__loading";
  globalLoading.innerHTML = "\n\t\t<div class=\"product-group-modal__loading-spinner\">\n\t\t\t<svg class=\"spinner\" viewBox=\"0 0 50 50\">\n\t\t\t\t<circle class=\"spinner__circle\" cx=\"25\" cy=\"25\" r=\"20\" fill=\"none\" stroke-width=\"4\"></circle>\n\t\t\t</svg>\n\t\t</div>\n\t";
  document.body.appendChild(globalLoading);
  document.addEventListener("click", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(event) {
      var trigger, handle, modal;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            trigger = event.target.closest("[data-product-group-trigger]");
            if (!trigger) {
              _context7.next = 19;
              break;
            }
            handle = trigger.dataset.productHandle;
            globalLoading.removeAttribute("hidden");
            globalLoading.offsetHeight;
            globalLoading.classList.add("is-visible");
            modal = document.querySelector("product-group-modal[data-product-handle=\"".concat(handle, "\"]"));
            if (!modal) {
              _context7.next = 17;
              break;
            }
            event.preventDefault();
            _context7.next = 11;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 100);
            });
          case 11:
            _context7.next = 13;
            return modal.show();
          case 13:
            globalLoading.classList.remove("is-visible");
            setTimeout(function () {
              globalLoading.setAttribute("hidden", "");
            }, 300);
            _context7.next = 19;
            break;
          case 17:
            globalLoading.classList.remove("is-visible");
            setTimeout(function () {
              globalLoading.setAttribute("hidden", "");
            }, 300);
          case 19:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x5) {
      return _ref3.apply(this, arguments);
    };
  }());
});

/***/ }),

/***/ "./src/js/modules/product-group/hydration.js":
/*!***************************************************!*\
  !*** ./src/js/modules/product-group/hydration.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   hydrateSection: () => (/* binding */ hydrateSection),
/* harmony export */   hydrateSections: () => (/* binding */ hydrateSections),
/* harmony export */   reinitializeProductGroup: () => (/* binding */ reinitializeProductGroup)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Finds a section container by ID with fallback to main-product
 * @param {string} sectionId - The section ID to find
 * @returns {HTMLElement} The found container
 * @throws {Error} If no container is found
 */
function findSectionContainer(sectionId) {
  var container = document.getElementById("shopify-section-".concat(sectionId));
  if (!container) {
    var fallbackContainer = document.getElementById("shopify-section-main-product");
    if (!fallbackContainer) {
      throw new Error("No container found for section: ".concat(sectionId, " or fallback"));
    }
    return fallbackContainer;
  }
  return container;
}
function hydrateSections(_x, _x2) {
  return _hydrateSections.apply(this, arguments);
}
function _hydrateSections() {
  _hydrateSections = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(handle, sectionIds) {
    var results, allSuccessful;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (handle) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", {
            success: false,
            results: {}
          });
        case 2:
          if (!(!Array.isArray(sectionIds) || sectionIds.length === 0)) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", {
            success: false,
            results: {}
          });
        case 4:
          results = {};
          allSuccessful = true;
          _context2.next = 8;
          return Promise.all(sectionIds.map(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(sectionId) {
              var response, html, container;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return fetch("/products/".concat(handle, "?section_id=").concat(sectionId));
                  case 3:
                    response = _context.sent;
                    if (response.ok) {
                      _context.next = 6;
                      break;
                    }
                    throw new Error("Failed to fetch section ".concat(sectionId, ": ").concat(response.statusText));
                  case 6:
                    _context.next = 8;
                    return response.text();
                  case 8:
                    html = _context.sent;
                    container = findSectionContainer(sectionId);
                    container.innerHTML = html;
                    results[sectionId] = true;
                    _context.next = 18;
                    break;
                  case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](0);
                    results[sectionId] = false;
                    allSuccessful = false;
                  case 18:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[0, 14]]);
            }));
            return function (_x4) {
              return _ref.apply(this, arguments);
            };
          }()));
        case 8:
          return _context2.abrupt("return", {
            success: allSuccessful,
            results: results
          });
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _hydrateSections.apply(this, arguments);
}
function hydrateSection(_x3) {
  return _hydrateSection.apply(this, arguments);
}
function _hydrateSection() {
  _hydrateSection = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(handle) {
    var sectionId,
      sectionInput,
      _yield$hydrateSection,
      success,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          sectionId = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : "main-product";
          if (handle) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", false);
        case 3:
          if (sectionId === "main-product") {
            sectionInput = document.querySelector('input[name="section-id"]');
            if (sectionInput !== null && sectionInput !== void 0 && sectionInput.value) {
              sectionId = sectionInput.value;
            }
          }
          _context3.next = 6;
          return hydrateSections(handle, [sectionId]);
        case 6:
          _yield$hydrateSection = _context3.sent;
          success = _yield$hydrateSection.success;
          return _context3.abrupt("return", success);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _hydrateSection.apply(this, arguments);
}
function reinitializeProductGroup() {
  return _reinitializeProductGroup.apply(this, arguments);
}
function _reinitializeProductGroup() {
  _reinitializeProductGroup = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var dataElement, groupData, container, _yield$import, ProductGroup, _yield$import2, HydrationManager, productGroup;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          dataElement = document.querySelector("[data-product-group]");
          if (dataElement) {
            _context4.next = 4;
            break;
          }
          return _context4.abrupt("return");
        case 4:
          groupData = JSON.parse(dataElement.textContent);
          container = document.querySelector(".product-group-selectors");
          if (container) {
            _context4.next = 8;
            break;
          }
          return _context4.abrupt("return");
        case 8:
          _context4.next = 10;
          return Promise.resolve(/*! import() */).then(__webpack_require__.bind(__webpack_require__, /*! ./ProductGroup */ "./src/js/modules/product-group/ProductGroup.js"));
        case 10:
          _yield$import = _context4.sent;
          ProductGroup = _yield$import.ProductGroup;
          _context4.next = 14;
          return Promise.resolve(/*! import() */).then(__webpack_require__.bind(__webpack_require__, /*! ./HydrationManager */ "./src/js/modules/product-group/HydrationManager.js"));
        case 14:
          _yield$import2 = _context4.sent;
          HydrationManager = _yield$import2.HydrationManager;
          productGroup = new ProductGroup(groupData);
          if (!productGroup.isInvalid()) {
            _context4.next = 19;
            break;
          }
          return _context4.abrupt("return");
        case 19:
          new HydrationManager({
            container: container,
            productGroup: productGroup,
            selectors: {
              typeSelector: '[data-group-selector="type"]',
              flavourSelector: '[data-group-selector="flavour"]'
            }
          });
          productGroup.initialize();
          _context4.next = 25;
          break;
        case 23:
          _context4.prev = 23;
          _context4.t0 = _context4["catch"](0);
        case 25:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 23]]);
  }));
  return _reinitializeProductGroup.apply(this, arguments);
}

/***/ }),

/***/ "./src/js/modules/product-group/index.js":
/*!***********************************************!*\
  !*** ./src/js/modules/product-group/index.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ProductGroup: () => (/* reexport safe */ _ProductGroup__WEBPACK_IMPORTED_MODULE_0__.ProductGroup),
/* harmony export */   ProductGroupModal: () => (/* reexport safe */ _ProductGroupModal__WEBPACK_IMPORTED_MODULE_2__.ProductGroupModal),
/* harmony export */   initProductGroup: () => (/* binding */ initProductGroup)
/* harmony export */ });
/* harmony import */ var _ProductGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ProductGroup */ "./src/js/modules/product-group/ProductGroup.js");
/* harmony import */ var _HydrationManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./HydrationManager */ "./src/js/modules/product-group/HydrationManager.js");
/* harmony import */ var _ProductGroupModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ProductGroupModal */ "./src/js/modules/product-group/ProductGroupModal.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }




/**
 * Centralized selector configuration
 */
var SELECTORS = {
  container: {
    productGroup: "[data-product-group]",
    selectors: ".product-group-selectors",
    sectionId: 'input[name="section-id"]',
    media: "product-media"
  },
  group: {
    type: '[data-group-selector="type"]',
    flavour: '[data-group-selector="flavour"]'
  }
};

/**
 * Default configuration for the product group module
 */
var DEFAULT_CONFIG = {
  selectors: {
    typeSelector: SELECTORS.group.type,
    flavourSelector: SELECTORS.group.flavour
  },
  mediaSectionId: "product-media-hydration"
};
var initialized = false;

/**
 * Validate product group data
 * @param {Object} groupData - The product group data to validate
 * @returns {boolean} Whether the data is valid
 */
function validateGroupData(groupData) {
  if (!groupData || _typeof(groupData) !== "object") {
    return false;
  }
  if (!groupData.groupId || typeof groupData.groupId !== "string") {
    return false;
  }
  if (!Array.isArray(groupData.groupedProducts)) {
    return false;
  }
  return true;
}

/**
 * Initialize product group functionality
 */
function initProductGroup() {
  if (initialized) return;
  var dataElement = document.querySelector(SELECTORS.container.productGroup);
  if (!dataElement) {
    return;
  }
  try {
    var groupData = JSON.parse(dataElement.textContent);
    if (!validateGroupData(groupData)) {
      return;
    }
    var container = document.querySelector(SELECTORS.container.selectors);
    if (!container) {
      return;
    }
    var productGroup = new _ProductGroup__WEBPACK_IMPORTED_MODULE_0__.ProductGroup(groupData);
    if (productGroup.isInvalid()) return;
    new _HydrationManager__WEBPACK_IMPORTED_MODULE_1__.HydrationManager({
      container: container,
      productGroup: productGroup,
      selectors: DEFAULT_CONFIG.selectors
    });
    productGroup.initialize();
    initialized = true;
  } catch (error) {
    // silent fail
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductGroup);
} else {
  initProductGroup();
}

/***/ }),

/***/ "./src/js/modules/product-group/storage.js":
/*!*************************************************!*\
  !*** ./src/js/modules/product-group/storage.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   clearSelections: () => (/* binding */ clearSelections),
/* harmony export */   getSelections: () => (/* binding */ getSelections),
/* harmony export */   hasValidSelections: () => (/* binding */ hasValidSelections),
/* harmony export */   storeSelections: () => (/* binding */ storeSelections)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Storage keys and constants
 */
var STORAGE_PREFIX = "product_group_";
var STORAGE_EXPIRY = 30 * 60 * 1000;

/**
 * Checks if sessionStorage is available
 * @returns {boolean} Whether sessionStorage is available
 */
function hasSessionStorage() {
  return typeof window !== "undefined" && window.sessionStorage;
}

/**
 * Creates a storage key for a product group
 * @param {string} groupId - The product group ID
 * @returns {string} Storage key
 */
function createStorageKey(groupId) {
  return "".concat(STORAGE_PREFIX).concat(groupId);
}

/**
 * Stores product selections in session storage
 * @param {string} groupId - The product group ID
 * @param {Object} selections - The selections to store
 * @param {string} currentProductHandle - The current product's handle
 * @returns {boolean} Whether storage was successful
 */
function storeSelections(groupId, selections, currentProductHandle) {
  if (!hasSessionStorage()) return false;
  try {
    var key = createStorageKey(groupId);
    var data = _objectSpread(_objectSpread({}, selections), {}, {
      lastUpdated: Date.now(),
      lastProductHandle: currentProductHandle
    });
    sessionStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * Retrieves product selections from session storage
 * @param {string} groupId - The product group ID
 * @param {string} currentProductHandle - The current product's handle
 * @returns {Object|null} Stored selections or null if not found/expired/invalid
 */
function getSelections(groupId, currentProductHandle) {
  if (!hasSessionStorage()) return null;
  try {
    var key = createStorageKey(groupId);
    var stored = sessionStorage.getItem(key);
    if (!stored) return null;
    var data = JSON.parse(stored);
    if (Date.now() - data.lastUpdated > STORAGE_EXPIRY) {
      sessionStorage.removeItem(key);
      return null;
    }
    if (data.lastProductHandle !== currentProductHandle) {
      sessionStorage.removeItem(key);
      return null;
    }
    return data;
  } catch (error) {
    return null;
  }
}

/**
 * Clears stored selections for a product group
 * @param {string} groupId - The product group ID
 * @returns {boolean} Whether clearing was successful
 */
function clearSelections(groupId) {
  if (!hasSessionStorage()) return false;
  try {
    var key = createStorageKey(groupId);
    sessionStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * Checks if stored selections exist and are valid
 * @param {string} groupId - The product group ID
 * @param {string} currentProductHandle - The current product's handle
 * @returns {boolean} Whether valid selections exist
 */
function hasValidSelections(groupId, currentProductHandle) {
  var selections = getSelections(groupId, currentProductHandle);
  return selections !== null && selections.lastSelectedType && selections.lastSelectedFlavour;
}

/***/ }),

/***/ "./src/js/modules/product-group/utils.js":
/*!***********************************************!*\
  !*** ./src/js/modules/product-group/utils.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createCombinationKey: () => (/* binding */ createCombinationKey),
/* harmony export */   debounce: () => (/* binding */ debounce),
/* harmony export */   isValidFlavour: () => (/* binding */ isValidFlavour),
/* harmony export */   isValidGroupId: () => (/* binding */ isValidGroupId),
/* harmony export */   isValidHandle: () => (/* binding */ isValidHandle),
/* harmony export */   isValidType: () => (/* binding */ isValidType),
/* harmony export */   logError: () => (/* binding */ logError),
/* harmony export */   normalize: () => (/* binding */ normalize)
/* harmony export */ });
/**
 * Normalizes a string value for consistent comparison and storage
 * @param {string} value - The value to normalize
 * @returns {string} Normalized string
 */
function normalize(value) {
  return (value || '').trim().toLowerCase().replace(/\s+/g, '_');
}

/**
 * Creates a consistent key for product combinations
 * @param {string} type - The product type
 * @param {string} flavour - The product flavour
 * @returns {string} Normalized combination key
 */
function createCombinationKey(type, flavour) {
  return "".concat(normalize(type), "|").concat(normalize(flavour));
}

/**
 * Standardized error logging
 * @param {string} context - The context of the error
 * @param {Error|string} error - The error to log
 */
function logError(context, error) {
  console.error("[\u274C ".concat(context, "]"), error);
}

/**
 * Validates a product type
 * @param {string} type - The type to validate
 * @returns {boolean} Whether the type is valid
 */
function isValidType(type) {
  return typeof type === 'string' && type.trim().length > 0;
}

/**
 * Validates a product flavour
 * @param {string} flavour - The flavour to validate
 * @returns {boolean} Whether the flavour is valid
 */
function isValidFlavour(flavour) {
  return typeof flavour === 'string' && flavour.trim().length > 0;
}

/**
 * Validates a product group ID
 * @param {string} groupId - The group ID to validate
 * @returns {boolean} Whether the group ID is valid
 */
function isValidGroupId(groupId) {
  return typeof groupId === 'string' && groupId.trim().length > 0;
}

/**
 * Debounces a function to prevent rapid firing
 * @param {Function} func - Function to debounce
 * @param {number} wait - Wait time in milliseconds
 * @param {boolean} immediate - Whether to call the function immediately
 * @returns {Function} Debounced function
 */
function debounce(func, wait) {
  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var timeout;
  return function executedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var later = function later() {
      clearTimeout(timeout);
      if (!immediate) func.apply(void 0, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(void 0, args);
  };
}

/**
 * Checks if a value is a valid product handle
 * @param {string} handle - The handle to validate
 * @returns {boolean} Whether the handle is valid
 */
function isValidHandle(handle) {
  return typeof handle === 'string' && handle.trim().length > 0;
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initializeGroupedProductModal: () => (/* binding */ initializeGroupedProductModal),
/* harmony export */   initializeProductGroup: () => (/* binding */ initializeProductGroup)
/* harmony export */ });
/* harmony import */ var _components_chat_icon_gorgias_chat_icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./components/chat-icon/gorgias-chat-icon */ "./src/js/components/chat-icon/gorgias-chat-icon.js");
/* harmony import */ var _components_chat_icon_gorgias_chat_icon__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_components_chat_icon_gorgias_chat_icon__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_product_group__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/product-group */ "./src/js/modules/product-group/index.js");
/* harmony import */ var _components_horizontal_slider_scrollable_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/horizontal-slider/scrollable-container */ "./src/js/components/horizontal-slider/scrollable-container.js");
/* harmony import */ var _modules_collection_hydration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/collection-hydration */ "./src/js/modules/collection-hydration/index.js");
/* harmony import */ var _components_mini_cart_mini_cart_discount__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/mini-cart/mini-cart-discount */ "./src/js/components/mini-cart/mini-cart-discount.js");
/* harmony import */ var _components_mini_cart_mini_cart_discount__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_mini_cart_mini_cart_discount__WEBPACK_IMPORTED_MODULE_4__);





var groupedModalInstance;
function initializeProductGroup() {
  var productGroupContainer = document.querySelector(".product-group-selectors");
  if (!productGroupContainer) {
    return;
  }
  (0,_modules_product_group__WEBPACK_IMPORTED_MODULE_1__.initProductGroup)();
}
function initializeGroupedProductModal() {
  if (!groupedModalInstance) {
    groupedModalInstance = new _modules_product_group__WEBPACK_IMPORTED_MODULE_1__.ProductGroupModal();
  }
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    initializeProductGroup();
    initializeGroupedProductModal();
    (0,_modules_collection_hydration__WEBPACK_IMPORTED_MODULE_3__.initCollectionHydration)();
    document.querySelectorAll(".scrollable-container").forEach(_components_horizontal_slider_scrollable_container__WEBPACK_IMPORTED_MODULE_2__["default"]);
  });
} else {
  initializeProductGroup();
  initializeGroupedProductModal();
  (0,_modules_collection_hydration__WEBPACK_IMPORTED_MODULE_3__.initCollectionHydration)();
  document.querySelectorAll(".scrollable-container").forEach(_components_horizontal_slider_scrollable_container__WEBPACK_IMPORTED_MODULE_2__["default"]);
}
document.addEventListener("shopify:section:load", function () {
  document.querySelectorAll(".scrollable-container").forEach(_components_horizontal_slider_scrollable_container__WEBPACK_IMPORTED_MODULE_2__["default"]);
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;
//# sourceMappingURL=neo-custom.js.map